<a nz-button nzType="link" nz-dropdown nzTrigger="click" [nzBackdrop]="false" [nzDropdownMenu]="menu">
  + {{ "word.select_option.add_filter" | translate }}
</a>

<nz-dropdown-menu #menu>
  <div class="v4-layout-dropdown" style="padding: 10px 15px">
    <div class="list">
      <div *ngFor="let opt of listOfOption" class="item py-1 cursor-pointer" (click)="onClickItem(opt)">
        <i class="text-primary" [class.invisible]="!value.has(opt.value)" nz-icon nzType="check" nzTheme="outline"></i>
        <span>
          {{ (opt.i18nKey | translate) || opt.label }}
        </span>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
